import { Component, Input } from '@angular/core';
import { WorkflowForm } from 'app/models/WorkflowForm';
import { ReviewHistoryEntryView } from 'app/models/form/ReviewHistoryEntryView';
import { REVIEW_HISTORY_ACTIONS } from 'app/models/form/review-history-action.constants';

@Component({
	selector: 'client-workflow-review-history-accordion',
	templateUrl: './workflow-review-history-accordion.component.html',
	styleUrls: ['./workflow-review-history-accordion.component.css'],
	standalone: false,
})
export class WorkflowReviewHistoryAccordionComponent {
	@Input() form: WorkflowForm | null = null;
	@Input() useAngularToggle = false;
	expanded = false;

	private readonly historyTriggerActions = new Set<string>([REVIEW_HISTORY_ACTIONS.SEND_BACK_TO_ADDRESS_COMMENTS]);

	toggleHistory(event: Event): void {
		if (!this.useAngularToggle) {
			return;
		}
		event.preventDefault();
		this.expanded = !this.expanded;
	}

	get reviewHistoryEntries(): ReviewHistoryEntryView[] {
		return this.form?.reviewHistoryEntries ?? [];
	}

	get shouldShowHistorySection(): boolean {
		return this.reviewHistoryEntries.some((entry) => this.historyTriggerActions.has(entry?.action));
	}
}
